export default __webpack_public_path__ + "static/media/Quarta.0ebde949.jpg";